<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      show-save-button
      unit="消费设备"
      edit-title
      id-key="DeviceId"
      :data="data"
      :form-rules="rules"
      :save-func="api.save"
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
      form-label-width="110px"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="设备编号" prop="DeviceNo">
              <el-input v-model="data.DeviceNo" v-int placeholder="请输入设备编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="设备名称" prop="DeviceName">
              <el-input v-model="data.DeviceName" placeholder="请输入设备名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="设备IP" prop="Ip">
              <el-input v-model="data.Ip" placeholder="请输入设备IP"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="端口号" prop="Port">
              <el-input v-model="data.Port" placeholder="请输入端口号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="UDP IP" prop="UdpIp">
              <el-input v-model="data.UdpIp" placeholder="请输入UDP IP"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="UDP端口" prop="UdpPort">
              <el-input v-model="data.UdpPort" placeholder="请输入UDP端口"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="单次消费限额" prop="SingleLimit">
              <el-input v-model="data.SingleLimit" v-snum></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="同卡刷卡间隔" prop="TimeLimit">
              <el-input v-model="data.TimeLimit" v-int></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="同卡刷卡间隔" prop="TimeLimit">
              <el-input v-model="data.TimeLimit" v-int></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="状态" prop="Status">
              <el-radio-group v-model="data.Status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="设备位置" prop="Place">
              <el-input v-model="data.Place" placeholder="请输入设备位置"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="设备地点" prop="Building">
              <el-input v-model="data.Building" placeholder="请输入设备地点" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="设备分组" prop="GroupName">
              <el-input v-model="data.GroupName" placeholder="请输入设备分组" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="isMB?24:12">
            <el-form-item label="楼层" prop="Floor">
              <el-input v-model="data.Floor" oninput="value=value.replace(/[^\d]/g,'')" type="number" placeholder="请输入楼层" clearable></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        DeviceId: 0,
        DeviceNo: "",
        DeviceName: "",
        Port: "",
        UdpIp: "",
        UdpPort: "",
        Ip: "",
        Place: "",
        Status: 1,
        SingleLimit: 0,
        TimeLimit: 0,
        // SendStudent: false,
        // SendTeacher: false,
        DeviceType: 0,
        Building: "",
        GroupName:"",
        Floor: "",
        // SendStatus: 1,
        // SendTime: this.$commonJs.getToday(),
      },
      isMB: this.$store.state.isMB,
      api: require("@/api/cp/device").default,
      rules: {
        DeviceNo: [{ required: true, message: "设备编号不能为空" }],
        DeviceName: [{ required: true, message: "设备名称不能为空" }],
        Ip: [{ required: true, message: "设备IP不能为空" }],
        Port: [{ required: true, message: "端口号不能为空" }],
        UdpIp: [{ required: true, message: "UDP IP不能为空" }],
        UdpPort: [{ required: true, message: "UDP端口不能为空" }],
        Place: [{ required: true, message: "设备位置不能为空" }],
        SingleLimit: [{ required: true, message: "默认消费限额不能为空" }],
        TimeLimit: [{ required: true, message: "同卡刷卡间隔不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onEditOpened(data) {},
  },
};
</script>